export const optionalNextStepTypes = ['Kolektivni dopust', 'Državni praznik', 'Vikend'];
